var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"label":"表情","items":_vm.faces,"value":_vm.value},on:{"input":function($event){_vm.$emit('input', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }